import { ActionKeys } from '~/actions/constants';
import * as notificationsActions from '~/actions/notifications.actions';
import { AxiosError } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as notificationsServices from '~/services/notifications.service';
import {
  NotificationsFormValues,
  NotificationsPayload,
  orderArrivedFieldsFromJSON,
  orderArrivedFieldsToJSON,
  orderShippedFieldsFromJSON,
  orderShippedFieldsToJSON,
} from '~/types/EmailNotifications';
import { Events, track } from '~/utils/segment';

export function* fetchNotificationSetting() {
  try {
    const response = yield call(notificationsServices.get);
    const payload: NotificationsFormValues = {
      autoEmailNotifications: response.data.notification_configs.UNKNOWN.is_auto_email_enabled,
      autoDeliveredEmailNotifications:
        response.data.notification_configs.DELIVERED.is_auto_email_enabled,
      autoOrderEmailDelayMinutes:
        response.data.notification_configs.UNKNOWN.auto_email_delay_minutes,
      autoOrderEmailCustomText: response.data.notification_configs.UNKNOWN.custom_text,
      autoDeliveredEmailCustomText: response.data.notification_configs.DELIVERED.custom_text,
    };
    yield put(notificationsActions.fetchNotificationsSuccess(payload));
  } catch (errorData) {
    const error = errorData as AxiosError;
    yield put(notificationsActions.fetchNotificationsError(error.response?.data));
  }
}

export function* sendSampleEmail(action: ReturnType<typeof notificationsActions.sendSampleEmail>) {
  try {
    // TODO: This is coded super weird. Refactor.
    const sendSampleEmailByType = () =>
      notificationsServices.sendSampleEmail(action.notificationType);
    const sendSampleEmailSuccessByType = () =>
      notificationsActions.sendSampleEmailSuccess(action.notificationType);
    yield call(sendSampleEmailByType);
    yield put(sendSampleEmailSuccessByType());
  } catch (error) {
    const sendSampleEmailErrorByType = () =>
      notificationsActions.sendSampleEmailError(action.notificationType);
    yield put(sendSampleEmailErrorByType());
  }
}

export function* updateOrderShippedEmailSettings(
  action: ReturnType<typeof notificationsActions.updateOrderShippedEmailSettings>,
) {
  const { orderShippedFormFields } = action.payload;
  const servicePayload: NotificationsPayload = {
    notification_configs: orderShippedFieldsToJSON(orderShippedFormFields),
  };
  try {
    const { data } = yield call(notificationsServices.put, servicePayload);
    const updatedFormFields = orderShippedFieldsFromJSON(data);
    yield put(notificationsActions.updateOrderShippedEmailSettingsSuccess(updatedFormFields));
    yield call(track, Events.email_notification_changed, {
      email_type: 'order_shipped',
      has_custom_text: updatedFormFields.orderShippingEmailContent.length > 0,
      is_enabled: updatedFormFields.orderShippingEmailEnabled,
    });
  } catch (err) {
    const axiosError = err as AxiosError;
    yield put(notificationsActions.updateOrderShippedEmailSettingsError(axiosError.response?.data));
  }
}

export function* updateOrderArrivedEmailSettings(
  action: ReturnType<typeof notificationsActions.updateOrderArrivedEmailSettings>,
) {
  const { orderArrivedFormFields } = action.payload;
  const servicePayload: NotificationsPayload = {
    notification_configs: orderArrivedFieldsToJSON(orderArrivedFormFields),
  };
  try {
    const { data } = yield call(notificationsServices.put, servicePayload);
    const updatedFormFields = orderArrivedFieldsFromJSON(data);
    yield put(notificationsActions.updateOrderArrivedEmailSettingsSuccess(updatedFormFields));
    yield call(track, Events.email_notification_changed, {
      email_type: 'order_delivered',
      has_custom_text: updatedFormFields.orderArrivedEmailContent.length > 0,
      is_enabled: updatedFormFields.orderArrivedEmailEnabled,
    });
  } catch (err) {
    const axiosError = err as AxiosError;
    yield put(notificationsActions.updateOrderArrivedEmailSettingsError(axiosError.response?.data));
  }
}

export default [
  takeLatest(ActionKeys.FETCH_NOTIFICATIONS, fetchNotificationSetting),
  takeLatest(ActionKeys.SEND_SAMPLE_EMAIL, sendSampleEmail),
  takeLatest(ActionKeys.UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS, updateOrderShippedEmailSettings),
  takeLatest(ActionKeys.UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS, updateOrderArrivedEmailSettings),
];
